// extracted by mini-css-extract-plugin
export var backupIcon = "_n7-1";
export var image = "_n7-0";